import React, {useEffect, useState} from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {Button, Card, Col, Dropdown, Layout, Menu, message, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import ProPortalHeader from "../../componets/ProPortalHeader";
import ProfileRow from "../../componets/ProfileRow";
import Navigator from "../../componets/Navigator";
import {useLocation, useNavigate} from "react-router-dom";
import {get_album_data} from "../services";
import {DownOutlined} from "@ant-design/icons";
import AlbumCollections from "../../ProDiscovery/DiscoveryAlbumSlickView";
import {AlbumSlider} from "./AlbumSlider";
import {TwitterPicker, CompactPicker, CirclePicker} from "react-color";
import {get_api, post_api} from "../../serverTemp";
import CoverLayout from "../../ProDiscovery/AlbumCoverLayout";
import {ReactComponent as DelIcon} from '../imgs/Delete.svg'
import {ReactComponent as PubIcon} from '../imgs/Publish.svg'
import {ReactComponent as RenameIcon} from '../imgs/Rename.svg'

const customColors = [
    {hex: '#FFFFFF', label: 'Multicolor'},
    {hex: '#A52A2A', label: 'Brown'},
    {hex: '#000000', label: 'Black'},
    {hex: '#008000', label: 'Green'},
    {hex: '#C0C0C0', label: 'Silver'},
    {hex: '#808080', label: 'Grey'},
    {hex: '#800080', label: 'Violet'},
    {hex: '#FFFFFF', label: 'White'},
    {hex: '#FF0000', label: 'Red'},
    {hex: '#0000FF', label: 'Blue'},
    {hex: '#FFFF00', label: 'Yellow'},
    {hex: '#FFA500', label: 'Orange'},
    {hex: '#800080', label: 'Purple'},
    {hex: '#4B0082', label: 'Indigo'},
    {hex: '#FFD700', label: 'Gold'},
    {hex: '#FFC0CB', label: 'Pink'},
];

const CustomColorPicker = ({colors, onColorChange}) => {
    return (
        <div className="custom-color-picker">
            {colors.map((color, index) => (
                <div key={color.hex} className={`color-swatch-container ${index >= 8 ? 'second-row' : ''}`}>
                    <div
                        className="color-swatch"
                        style={{backgroundColor: color.hex}}
                        onClick={() => onColorChange(color.hex)}
                    />
                    <div className="color-label">{color.label}</div>
                </div>
            ))}
        </div>
    );
};

const picker = (
    <CustomColorPicker
        colors={customColors}
        onColorChange={(color) => {
            //     TODO
        }}
    />
);
const Albums = (props) => {
    const [albums, setAlbums] = useState([])
    const navigate = useNavigate()
    const {state} = useLocation()
    const textura_ids = state?.textura_ids || []
    const [isColorVisible, setIsColorVisible] = useState(false)
    const [activeTab, setActiveTab] = useState('curated');
    const [stat, setStat] = useState({})
    const [user, setUser] = useState({})
    useEffect(() => {
        get_api('/textura/status/statictics').then(res => {
            setStat(res)
        })
    }, []);
    useEffect(() => {
        get_api('/user/detail').then(res => {
            setUser(res)
        })
    }, [])
    const subsMap = {
        0: "Standard",
        1: "Advanced",
        2: "Premium"
    }
    const hospitalityMenu = () => (
        <div className={'ds-dropdown-al-hos'}>
            <Menu onClick={(e) => {
                switch (e.key) {
                    case '1':
                        break;
                    default:
                        break;
                }
            }}>
                {/*{groups?.map((item, idx) => <Menu.Item key={item?.key}>{item?.title}</Menu.Item>)}*/}
                <Menu.Item key={'1'}>Hotels</Menu.Item>
                <Menu.Item key={'2'}>Restaurants</Menu.Item>
                <Menu.Item key={'3'}>Cafes and Coffee shops</Menu.Item>
                <Menu.Item key={'4'}>Bars and Pubs</Menu.Item>
            </Menu>
        </div>
    );
    const HWMenu = () => (
        <div className={'ds-dropdown-al-hw'}>
            <Menu onClick={(e) => {
                switch (e.key) {
                    case '1':
                        break;
                    default:
                        break;
                }
            }}>
                {/*{groups?.map((item, idx) => <Menu.Item key={item?.key}>{item?.title}</Menu.Item>)}*/}
                <Menu.Item key={'1'}>Nursing Home</Menu.Item>
                <Menu.Item key={'2'}>Hospitals and Health Care</Menu.Item>
                <Menu.Item key={'3'}>Beauty Salons and Spas</Menu.Item>
            </Menu>
        </div>
    );
    useEffect(() => {
        get_api(activeTab === 'curated' ? '/playlist/all' : '/album/all').then(
            res => {
                const abData = res.data
                if (!abData || abData.length === 0) {
                    message.error('No album found')
                } else {
                    setAlbums(abData.map(album => {
                        console.log(album)
                        return {
                            id: album.id,
                            name: album.name,
                            urls: album.url,
                            item: {
                                left: album?.url?.split(',')[0] ?? null,
                                upRight: album?.url?.split(',')[1] ?? null,
                                downRight: album?.url?.split(',')[2] ?? null,
                            }
                        }
                    }))
                }
            }
        )
    }, [activeTab])
    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <Row style={{
                    margin: textura_ids.length === 0 ? '-6rem 0 0 0' : '8rem 0 0 0',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Col lg={4} style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: 'column'
                    }}>
                        <div className={'pt-profile-div'}>
                            <img className={'pt-profile-div-img'}
                                 src={user?.avatar}
                                 style={{
                                     cursor: 'pointer'
                                 }}
                                 alt={'avatar'}
                                 onClick={() => {
                                     window.location.href = '/proportal/AccountSettings'
                                 }}
                            />
                        </div>
                        <p className={'bp-ds-profile-txt'} style={{
                            marginTop: '1rem',
                        }}>
                            {user?.nickname}
                        </p>
                        <p className={'bp-ds-profile-txt'}>
                            {user?.email}
                        </p>
                        <p className={'bp-ds-profile-txt'} style={{
                            marginBottom: '1rem'
                        }}>
                            {subsMap[user?.subscription]}
                        </p>
                    </Col>

                    {textura_ids.length > 0 && <Col xl={15} lg={10}>
                        <div className="al-ma-tabs-container">
                            <Button
                                className={`${activeTab === 'curated' ? 'al-ma-active-tab' : 'al-ma-inactive-tab'}`}
                                onClick={() => setActiveTab('curated')}
                            >
                                My Vieunite Collection
                            </Button>
                            <Button
                                className={`${activeTab === 'albums' ? 'al-ma-active-tab' : 'al-ma-inactive-tab'}`}
                                onClick={() => setActiveTab('albums')}
                                style={{width: '250px'}}
                            >
                                My Albums
                            </Button>
                        </div>
                    </Col>}
                </Row>
                <Row>
                    <Layout>
                        <Navigator/>
                        {activeTab === 'curated' && <Layout>
                            <Row style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                margin: '0 0 2rem 0'
                            }}>
                                <p className={'mb-dsp-title'} style={{marginLeft: '7.8vw',fontWeight:'600'}}>
                                    Vieunite Curated Collection
                                </p>
                            </Row>
                            <Row style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                margin: '4vh 0 -2vh 7.8vw'
                            }}>
                                <Button className={'album-filter-btn'} style={{
                                    marginRight: '1vw'
                                }}>Portrait</Button>
                                <Button className={'album-filter-btn'}>Landscape</Button>
                            </Row>
                            <div className="al-collections-container" style={{margin: "80px 35px 0 35px"}}>
                                <p className='album-collection-title'
                                   style={{margin: '0 0 0 6vw'}}
                                > {'Art Categories'} </p>
                                <Row justify={"start"} style={{
                                    margin: '0 0 0 6vw',
                                    gap: '20px'
                                }}>
                                    <Button className={'album-ct-btn'}>Painting</Button>
                                    <Button className={'album-ct-btn'}>Photography</Button>
                                    <Button className={'album-ct-btn'}>On Paper</Button>
                                    <Button className={'album-ct-btn'}>Moving Image</Button>
                                    <Button className={'album-ct-btn'}>Digital Art</Button>
                                </Row>
                                <AlbumSlider albums={albums} textura_ids={textura_ids}/>
                            </div>
                            <div className="al-collections-container" style={{margin: "80px 35px 0 35px"}}>
                                <p className='album-collection-title'
                                   style={{margin: '0 0 0 6vw'}}
                                > {'Industry Categories'} </p>
                                <Row justify={"start"} style={{
                                    margin: '0 0 0 6vw',
                                    gap: '20px'
                                }}>
                                    <Dropdown className={'ds-dropdown'}
                                              overlay={hospitalityMenu}
                                              placement={"bottom"}>
                                        <Button className={'album-ct-btn'} style={{
                                            width: 180,
                                            height: '42px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            Hospitality
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9"
                                                 viewBox="0 0 13 9"
                                                 fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M11.2958 1.13021C11.6863 0.739686 12.3195 0.739686 12.71 1.13021C13.1006 1.52073 13.1006 2.1539 12.71 2.54442L9.59914 5.65532L7.90057 7.35389L7.92934 7.38266L6.51512 8.79688L0.293323 2.57508C-0.0972016 2.18455 -0.0972017 1.55139 0.293323 1.16086C0.683847 0.770338 1.31701 0.770338 1.70754 1.16086L6.48635 5.93968L8.18492 4.24111L11.2958 1.13021Z"
                                                      fill="#0E487A"/>
                                            </svg>
                                        </Button>
                                    </Dropdown>
                                    <Dropdown className={'ds-dropdown'}
                                              overlay={HWMenu}
                                              placement={"bottom"}>
                                        <Button className={'album-ct-btn'} style={{
                                            width: 240,
                                            height: '42px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            Health & Wellbeing
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9"
                                                 viewBox="0 0 13 9"
                                                 fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M11.2958 1.13021C11.6863 0.739686 12.3195 0.739686 12.71 1.13021C13.1006 1.52073 13.1006 2.1539 12.71 2.54442L9.59914 5.65532L7.90057 7.35389L7.92934 7.38266L6.51512 8.79688L0.293323 2.57508C-0.0972016 2.18455 -0.0972017 1.55139 0.293323 1.16086C0.683847 0.770338 1.31701 0.770338 1.70754 1.16086L6.48635 5.93968L8.18492 4.24111L11.2958 1.13021Z"
                                                      fill="#0E487A"/>
                                            </svg>
                                        </Button>
                                    </Dropdown>
                                    <Button className={'album-ct-btn'}>Retail</Button>
                                    <Button className={'album-ct-btn'} style={{
                                        width: '276px'
                                    }}>Business & Corporate</Button>
                                    <Button className={'album-ct-btn'}>Educational</Button>
                                    <Button className={'album-ct-btn'}>Travel</Button>
                                    <Button className={'album-ct-btn'}>Others</Button>
                                </Row>
                                <AlbumSlider albums={albums} textura_ids={textura_ids}/>
                            </div>
                            <div className="al-collections-container" style={{margin: "80px 35px 0 35px"}}>
                                <p className='album-collection-title'
                                   style={{margin: '0 0 0 6vw'}}
                                > {'Mood & Themes'} </p>
                                <Row justify={"start"} style={{
                                    margin: '0 0 0 6vw',
                                    gap: '20px'
                                }}>
                                    <Button className={'album-ct-btn'}>Curatorial</Button>
                                    <Button className={'album-ct-btn'}>Biophilia</Button>
                                    <Button className={'album-ct-btn'} style={{
                                        width: '276px'
                                    }}
                                    >Architecture & Interiors</Button>
                                    <Button className={'album-ct-btn'}>Masterpiece</Button>
                                    <Button className={'album-ct-btn'} style={{
                                        width: '276px'
                                    }}>Food & Drink</Button>
                                    <Button className={'album-ct-btn'}>Spirituality</Button>
                                    <Button className={'album-ct-btn'} style={{
                                        width: '276px'
                                    }}>Strange & Funny</Button>
                                    <Button className={'album-ct-btn'}>Seasonal</Button>
                                </Row>
                                <AlbumSlider albums={albums} textura_ids={textura_ids}/>
                            </div>
                            <div className="al-collections-container" style={{margin: "80px 35px 8rem 35px"}}>
                                {/*<p className='album-collection-title'*/}
                                {/*   style={{margin: '0 0 0 4rem'}}*/}
                                {/*> {'Colour'} </p>*/}
                                <Row justify={"start"} style={{
                                    margin: '0 0 0 6vw',
                                    gap: '20px'
                                }}>

                                    <Dropdown visible={isColorVisible} overlay={picker}>
                                        <Button
                                            className={'album-ct-btn'}
                                            onClick={() => setIsColorVisible(!isColorVisible)}
                                        >
                                            Colour >
                                        </Button>
                                    </Dropdown>
                                </Row>
                                <AlbumSlider albums={albums} textura_ids={textura_ids}/>
                            </div>
                        </Layout>}
                        {activeTab === 'albums' && <Layout>
                            <Row style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                margin: '0 0 2rem 0'
                            }}>
                                <p className={'mb-dsp-title'} style={{margin: '4rem 0 -2rem 4.4rem'}}>
                                    My Albums
                                </p>
                            </Row>
                            <Row justify={"flex-start"}
                                 style={{margin: '4rem 0 100rem 0'}}
                            >
                                {albums.length > 0 ?
                                    albums.map((album, index) => {
                                        return (
                                            <div className={'mb-album-card'}>
                                                {album?.urls?.split(',').length >= 3 ?
                                                    <CoverLayout
                                                        // onClick={() => {
                                                        //     navigate('/proportal/images', {
                                                        //         state: {
                                                        //             albumID: album.id,
                                                        //             title: album.name,
                                                        //             filter: 'album'
                                                        //         }
                                                        //     })
                                                        // }}
                                                        item={album?.item}
                                                        style={{
                                                            width: 200,
                                                            height: 200,
                                                            marginLeft: 10,
                                                            marginTop: 10,
                                                            marginRight: 10,
                                                            marginBottom: 0
                                                        }}/>
                                                    :
                                                    <img
                                                        // onClick={() => {
                                                        //     navigate('/proportal/images', {
                                                        //         state: {
                                                        //             albumID: album.id,
                                                        //             title: album.name,
                                                        //             filter: 'album'
                                                        //         }
                                                        //     })
                                                        // }}
                                                        src={album.urls.split(',')[0]} alt="Album cover"
                                                        style={{
                                                            width: "80%",
                                                            height: "50%",
                                                            objectFit: "cover",
                                                            cursor: 'pointer',
                                                        }}/>
                                                }
                                                <p className={'mb-album-name'}>
                                                    {album?.name}
                                                </p>
                                                <div className={'mb-album-ops'}>
                                                    <div style={{
                                                        cursor: 'pointer', display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'column',
                                                        margin:'auto'
                                                    }}
                                                         onClick={() => {
                                                             if (textura_ids.length > 0) {
                                                                 window.alert('Succeed!')
                                                             } else {
                                                                 navigate('/proportal/dashboard', {state: {album_id: album.id}})
                                                             }
                                                         }}
                                                    >
                                                        <PubIcon/>
                                                        <p className={'ml-p-small-icon'}>PUBLISH</p>
                                                    </div>
                                                    {/*<div style={{*/}
                                                    {/*    cursor: 'pointer', display: 'flex',*/}
                                                    {/*    alignItems: 'center',*/}
                                                    {/*    flexDirection: 'column',*/}
                                                    {/*}}*/}
                                                    {/*     onClick={() => {*/}
                                                    {/*         setIsNewAlbum(false)*/}
                                                    {/*         setCurAlbumID(album.id)*/}
                                                    {/*         setIsModalOpen(true)*/}
                                                    {/*     }}>*/}
                                                    {/*    <RenameIcon/>*/}
                                                    {/*    <p className={'ml-p-small-icon'}>RENAME</p>*/}
                                                    {/*</div>*/}
                                                    {/*<div style={{*/}
                                                    {/*    cursor: 'pointer',*/}
                                                    {/*    display: 'flex',*/}
                                                    {/*    alignItems: 'center',*/}
                                                    {/*    flexDirection: 'column',*/}
                                                    {/*}}*/}
                                                    {/*     onClick={() => {*/}
                                                    {/*         post_api('/album/delete', {*/}
                                                    {/*             id: album.id*/}
                                                    {/*         }).then(*/}
                                                    {/*             res => {*/}
                                                    {/*                 window.location.reload()*/}
                                                    {/*             }*/}
                                                    {/*         )*/}
                                                    {/*     }}>*/}
                                                    {/*    <DelIcon/>*/}
                                                    {/*    <p className={'ml-p-small-icon'}>DELETE</p>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>
                                        )
                                    }) : <></>
                                }
                            </Row>
                        </Layout>}
                    </Layout>
                </Row>
            </Content>
        </Layout>
    )
}

export default Albums;
